import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout.js';
import * as General from '../General/General.js';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import {Modal} from "react-bootstrap";
import Delete from '../Delete/Delete.js';

const SuggestionProductIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const DeleteRef = useRef()
    const [SuggestionProductList, setSuggestionProductList] = useState([]);
    const [Id, setId] = useState(0);

    const [SearchTitle, setSearchTitle] = useState('');
    const [SearchIsActive, setSearchIsActive] = useState(1);
    const [Title, setTitle] = useState('');
    const [IsActive, setIsActive] = useState(true);
    const [Current, setCurrent] = useState(0);
    const [Voltage, setVoltage] = useState(220);
    const [Type, setType] = useState(-1);
    const [Power, setPower] = useState(0);
    const [ShowModal, setShowModal] = React.useState(false);
    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false)

    //#endregion

    //#region Methods

    const Search = () => {
        var RequestOptions = {
            data: {
                "IsActive": SearchIsActive,
                "Title": SearchTitle
            },
            url: General.ApiRoute() + "/SuggestionProduct/Search",
            method: "Post",
            withCredentials: true,
            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json',
            }
        }
        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    var tmp = []
                    for (var i = 0; i < result.data.length; i++) {
                        tmp.push({
                            Row: i + 1,
                            Id: result.data[i].id,
                            Title: result.data[i].title,
                            IsActive: result.data[i].isActive,
                            Current: result.data[i].current,
                            Power: result.data[i].power,
                            TypeComment: result.data[i].typeComment
                        })
                    }
                    setSuggestionProductList(tmp)
                    console.dir(tmp)

                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }



    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };


    const Reset = () => {
        setTitle("");
        setId(0);
        setIsActive(true);
        setPower(0);
        setCurrent(0);

    }

    const Save = () => {
        if (Title == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("عنوان اجباری می باشد")), 'topCenter')
            return;
        }
        if (Power == 0) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("توان مصرفی اجباری می باشد")), 'topCenter')
            return;
        }
        if (Current == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("جریان اجباری می باشد")), 'topCenter')
            return;
        }
        var RequestOptions = {
            data: {
                "Id": Id,
                "Title": Title,
                "Power": Power,
                "Current": Current,
                "Type": Type,
                "IsActive": IsActive ? 1 : 0,
            },
            url: General.ApiRoute() + "/SuggestionProduct/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')

                        Search();
                        Reset();
                        if (Id != 0)
                            setShowModal(false);
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }

    const ShowDelete = (id, title) => {
        DeleteRef.current.Get(20, id, title);
    }

    const ShowEdit = (Id) => {
        Reset();
        setId(Id);
        setShowModal(true);
        trackPromise(
            fetch(General.ApiRoute() + '/SuggestionProduct/GetById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': Id
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    setTitle(result.title);
                    setCurrent(result.current);
                    setPower(result.power)
                    setType(result.type)
                    setIsActive(result.isActive == 0 ? false : true);
                })
        )
    }

    const ShowNew = () => {
        setShowModal(true);
        Reset();
    }

    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 20);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        Search();

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    useEffect(() => {
        CheckPermission();
        document.title = "تعریف محصول جهت پیشنهاد موتور برق";
    }, [])
    //#endregion







    return (

        <Layout title='تعریف محصول جهت پیشنهاد موتور برق'>


            <div className="h-100 p-1">
                <rsuite.Panel className="bg-white h-10 ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={Search}>  جستجو</rsuite.Button>
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={ShowNew}>  جـــدید</rsuite.Button>
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>
                        <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                            <label>عتوان   </label>
                            <rsuite.Input value={SearchTitle} onChange={(e) => setSearchTitle(e)} />
                        </rsuite.Col>

                        <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                            <label> وضعیت فعال بودن   </label>
                            <select className="rs-input" onChange={(e) => setSearchIsActive(e.target.value)} value={SearchIsActive}>
                                <option value="-1">انتخاب نمایید</option>
                                <option value="0">غیر فعال </option>
                                <option value="1">فعال </option>
                            </select>
                        </rsuite.Col>



                    </rsuite.Row>
                    <hr />
                    <div className="h-90 p-1">
                        <div className="h-100-y">

                            <rsuite.Panel className="bg-white mt-2">

                                <rsuite.Table
                                    height={600}
                                    data={SuggestionProductList.sort((a, b) => {
                                        let x = a[sortColumn];
                                        let y = b[sortColumn];
                                        if (typeof x === 'string') {
                                            x = x.charCodeAt();
                                        }
                                        if (typeof y === 'string') {
                                            y = y.charCodeAt();
                                        }
                                        if (sortType === 'asc') {
                                            return x - y;
                                        } else {
                                            return y - x;
                                        }
                                    })}
                                    sortColumn={sortColumn}
                                    sortType={sortType}
                                    onSortColumn={handleSortColumn}
                                    loading={loading}

                                >
                                    <rsuite.Table.Column className="w-10p" align="center" fixed sortable>
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Row" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column flexGrow={2} fullText sortable resizable>
                                        <rsuite.Table.HeaderCell>دسته لوازم</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="TypeComment" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column flexGrow={2} fullText sortable resizable>
                                        <rsuite.Table.HeaderCell>عنوان</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Title" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column flexGrow={1} fullText sortable resizable>
                                        <rsuite.Table.HeaderCell>توان مصرفی W</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Power" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column flexGrow={1} fullText sortable resizable>
                                        <rsuite.Table.HeaderCell>جریان مصرفی A</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Current" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column fullText width={100} resizable>
                                        <rsuite.Table.HeaderCell>فعال   </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>

                                                    {rowData.IsActive == 1 ?

                                                        <BiIcon.BiCheckCircle className="text-success fs-6" />
                                                        :
                                                        <BiIcon.BiXCircle className="text-danger fs-6" />
                                                    }
                                                </>


                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>


                                    <rsuite.Table.Column width={60} fixed="right" >
                                        <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>

                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                        <rsuite.Popover full className='PopoverMenu'>
                                                            <rsuite.Dropdown.Menu  >
                                                                <rsuite.Dropdown.Item onClick={() => ShowEdit(rowData.Id)}>ویرایش</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item onClick={() => ShowDelete(rowData.Id, rowData.Title)}>حذف</rsuite.Dropdown.Item>
                                                            </rsuite.Dropdown.Menu>
                                                        </rsuite.Popover>
                                                    }>
                                                        <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                    </rsuite.Whisper>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>
                                </rsuite.Table>

                            </rsuite.Panel>

                        </div>
                    </div>

                </rsuite.Panel >
            </div >




            <Modal show={ShowModal} onHide={() => setShowModal(false)} size="md" backdrop="static" keyboard={false} >
                <Modal.Header >
                    <Modal.Title className='fs-5'><b>تعریف محصول  </b></Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <rsuite.Grid fluid>
                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={Type == "-1" ? 'text-danger' : 'hide'} />  <label>دسته لوازم</label>
                                <select className="rs-input FocusItem" value={Type}
                                    // onKeyDown={(e) => handelKeyDown(e, "TransferType")}
                                    onChange={(e)=>setType(e.target.value)}>
                                    <option value="-1">انتخاب نمایید</option>
                                    <option value="1">لوازم آشپزخانه</option>
                                    <option value="2">لوازم صوتی تصویری</option>
                                    <option value="3">لوازم سرمایشی و گرمایشی</option>
                                    <option value="4">سایر لوازم خانگی کوچک</option>
                                </select>
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={Title == "" ? 'text-danger' : 'hide'} />  <label>عنوان</label>
                                <rsuite.Input value={Title} onChange={(e) => setTitle(e)} />
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={Power == 0 ? 'text-danger' : 'hide'} />  <label>توان (W)</label>
                                <rsuite.Input value={Power} onChange={(e) => (setPower(e), setCurrent(Number.parseFloat(e / Voltage).toFixed(2)))} />
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={Current == 0 ? 'text-danger' : 'hide'} />  <label>جریان (A)</label>
                                <rsuite.Input value={Current} onChange={(e) => setCurrent(e)} />
                            </rsuite.Col>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <rsuite.Checkbox onChange={(e, checked) => setIsActive(checked)} checked={IsActive} value={IsActive} /> &nbsp; فعال می باشد

                            </rsuite.Col>


                        </rsuite.Row>

                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>
                    <rsuite.Button appearance="primary" color="green" onClick={Save}>
                        ذخیره
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setShowModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>

            <Delete ref={DeleteRef} onSubmit={Search} />
        </Layout >


    )
}

export default SuggestionProductIndex;